import { useTranslation } from 'react-i18next';
import { StatusPill } from '../../components/ui/StatusPill';
import { StatusIcon } from '../../components/ui/StatusIcon';
import { stoppedColor } from '../../components/domain/statusColor';

/** Amber "Stopped" pill with the shared warning icon (R14): icon + word + colour, never colour alone. */
export function StoppedPill() {
  const { t } = useTranslation();
  const c = stoppedColor();
  return (
    <StatusPill
      bg={c.bg}
      text={c.text}
      label={t('stops.pill')}
      icon={<StatusIcon name="warning" size={14} />}
    />
  );
}
